import { call, put, takeLatest } from 'redux-saga/effects';
import ShippingAddressAction, { shippingAddressTypes } from "redux/actions/shippingAddressAction";
import ShippingServices from 'services/shippingServices';
import BaseAction from '../actions/baseAction';

export function* getConfigAdd(): any {
  try {
    const result = yield call(ShippingServices.getJsonConfigAddressFields);
    if (result.status === 200) {
      yield put(ShippingAddressAction.getConfigAddressFieldsSuccess(result.data));
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `GET_CONFIG_ADDRESS_FIELDS ${error}`
    }));
  }
}

export const watchShippingAddress = [
  takeLatest(shippingAddressTypes.GET_CONFIG_ADDRESS_FIELDS, getConfigAdd),
]
